import React from 'react';
import { useObservable } from 'react-use-observable';

import { Tooltip, Typography } from 'antd';

import ColoredFormattedNumber from 'components/ColoredFormattedNumber';
import chargebackService from 'v2/services/chargeback';

import { Icon } from '@eduzz/ui-antd-theme';

import ExportChargeback from './Export';

const Totalizers = () => {
  const [totalItems] = useObservable(() => chargebackService.getTotalItems(), []);
  const [isLoading] = useObservable(() => chargebackService.isLoading(), []);
  const [getTotalChargeback] = useObservable(() => chargebackService.getTotalChargeback(), []);

  const chargebacksCount = `${totalItems} Chargeback${totalItems > 1 ? 's' : ''}`;

  if (isLoading) {
    return null;
  }

  return (
    <div id='chargebacks-totalizers' className='mb-4 flex flex-wrap items-center justify-between gap-4'>
      <Typography.Text>
        {chargebacksCount}
        <Typography.Text type='secondary'> · </Typography.Text>
        Total de Chargeback:{' '}
        <Typography.Text strong>
          <ColoredFormattedNumber value={getTotalChargeback || 0} format='BRL' />
        </Typography.Text>
        <Tooltip title='Valor total das faturas em chargeback' placement='top'>
          <Typography.Text type='secondary' className='ml-1 inline-flex align-middle'>
            <Icon.CircleHelp size={16} />
          </Typography.Text>
        </Tooltip>
      </Typography.Text>
      <ExportChargeback />
    </div>
  );
};

export default Totalizers;
